import AlertService from './components/UIElements/AlertService';
import AppRoutes from './routes/AppRoutes';
import './styles/tailwind.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <>
      <AppRoutes />
      <AlertService />
    </>
  );
}

export default App;
